import { QueryClient } from '@tanstack/react-query'

// Define minimal types to replace @sentry/core imports

export type SeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug'

type SpanAttributeValue =
  | string
  | number
  | boolean
  | Array<null | undefined | string>
  | Array<null | undefined | number>
  | Array<null | undefined | boolean>

export const SPAN_STATUS_UNSET = 0
export const SPAN_STATUS_OK = 1
export const SPAN_STATUS_ERROR = 2
/** The status code of a span. */
export type SpanStatusCode =
  | typeof SPAN_STATUS_UNSET
  | typeof SPAN_STATUS_OK
  | typeof SPAN_STATUS_ERROR

interface SpanStatusType {
  code: SpanStatusCode
}

interface Span {
  setStatus(status: SpanStatusType): void
  end(): void
}

interface StartSpanOptions {
  op: string
  name: string
  attributes?: Record<string, SpanAttributeValue | undefined>
}

/** Init params */
export interface InitParams {
  endpoint: string
  queryClient: QueryClient
  reportError: (e: unknown, level: SeverityLevel, extra?: Record<string, unknown>) => void
  getAuthToken?: (forceRefresh?: boolean) => Promise<string | undefined>
  sentry?: {
    env: string
    startSpan: <T>(options: StartSpanOptions, callback: (span: Span) => T) => T
  }
  options?: {
    // Applied only for requests with auth
    headers?: Record<string, string>
  }
}
